import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_SelectedMerchantProduct,
  STORE_FAVOURITE_MERCHANT_LIST,
  STORE_CustomerDefaultAddress,
  STORE_dtoCustomerAddressList,
  STORE_ISFORCE_TO_SIGN_OUT,
  STORE_HardReleaseVersion,
  STORE_MobileAppCategory,
  STORE_dtoMobileSettings,
  TEMP_STORE_CustomerName,
  STORE_CartCheckoutData,
  STORE_SelectedMerchant,
  STORE_SHEDULEDateNTime,
  STORE_MERCHANT_SCROLL,
  STORE_ZoneDescription,
  STORE_DeliveryZoneID,
  STORE_RATING_POSID,
  TEMP_STORE_PhoneNo,
  STORE_CustomerName,
  STORE_PROMOTIONS,
  STORE_PROMO_DATA,
  TEMP_STORE_CSID,
  TEMP_STORE_OTP,
  STORE_MERCHANT,
  STORE_DineType,
  STORE_PhoneNo,
  STORE_ZoneId,
  STORE_Addons,
  STORE_MTYPE,
  STORE_Cart,
  STORE_CSID,
  STORE_CSP,
  STORE_NIC,
  SECRET_KEY,
  CODE,
  ENTRY_MODE,
  MID,
  TABLE_NO,
} from "../../database/store-names";
import {
  SET_ZONE_DESCRIPTION_HOME_SCREEN,
  ENCRYPT_STORAGE,
  SET_STARTUP,
  CSP,
} from "../../config/config";
import {
  api_checkAppStoreVersion,
  api_LoadMerchantForMID,
  api_StartupPageLoad,
  api_LoadMerchant,
} from "../../connection/api/api-home";
import {
  DRAWER_HOME_SCREEN_ZONE_BUTTON_CLICK_EVENT,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  DIFERENCE_MINUTES,
} from "../../functions/funtion";
import {
  GET_PUSHNOTIFICATION_REDIRECT_URL,
  GET_SET_STORED_DATA,
} from "../../database/get-stored-data";
import {
  set_dto_StartupPageLoadInfo,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import {
  api_LoadCustomerWiseMerchantFavouriteListToMemory,
} from "../../connection/api/api-profile";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { api_LoadPromotionCategorySection } from "../../connection/api/api-Machine-Learning";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { api_DaitonnAnalytical } from "../../connection/api/api-Machine-Learning";
import {
  SET_STORE_PAGE_URL,
} from "../../database/store-data";
import { SET_UPDATE_URL } from "../../util/update-config";
import { dto_Customer } from "../../classes/dto-customer";
import { VALIDATE_CSP } from "../../config/csp";
import { dto_common } from "../../classes/dto-common";
import { SET_COLORS } from "../../util/color-config";
import { CHECK_NIC } from "../../functions/common-screen-functions";
import { Container } from "react-bootstrap";
import { PT_SIGNIN } from "../../routes/stack/paths/pt-profile";
import { isMobile } from "react-device-detect";
import { Update } from "../../util/updateUrl";
import RENDER_DRAWER_ZONE from "../../components/render-drawer-zone/render-drawer-zone";
import AVHomePlaceholder from "./components/home-placeloader/AV-home-placeloader";
import MKhomePlaceholder from "./components/home-placeloader/MK-home-placeloader";
import DThomePlaceholder from "./components/home-placeloader/DT-home-placeloader";
import ViewCategoryMK from "./components/horizontal-category/view-categoryMK";
import ViewCategory from "./components/horizontal-category/view-category";
import MerchantCard from "./components/merchant-card/merchant-card";
import SliderImage from "../../components/image-slider/image-slider";
import ViewSection from "./components/horizontal-view-section/view-section";
import PromoCard from "./components/promo/promo";
import Sections from "./components/section";
import RateNow from "../orders/components/rate-now/rate-now";
import React from "react";
import ALert from "../../components/Alert";
import "../../styles/css/common-loader.css";
import "./components/promo/promo.css";
import { dto_Merchant } from "../../classes/dto-merchant";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
var $ = require("jquery");

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      NoOfMerchants: 0,
      NoOfMobileAppCategory: 0,
      NoOfSection: 0,
      MerchantData: [],
      MerchantData2: [],
      MasterCategory: [],
      MobileAppCategoryDate: [],
      SectionsData: [],
      ZoneModelOpen: false,
      POSID: 0,
      Promo: 0,
      startY: null,
      FavouriteMerchant: null,
      isDisplayFavourites: false,
      CategoryList: [],
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.RenderMerchantAndSection = this.RenderMerchantAndSection.bind(this);
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    if (CSP !== "AV") {
      if (dto_common.ZoneId === 0) {
        dto_common.ZoneId = 1;
        dto_common.ZoneDescription = "Dehiwala";
      }
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
      await this.LoadMerchant();
      await this.LoadSection();
      await this.RenderMerchantAndSection();
    } else {
      SET_ZONE_DESCRIPTION_HOME_SCREEN(dto_common.ZoneDescription);
    }

    if (CSP === "MK") {
      await this.LoadMasterCategoryForMKB();
    }

    await DRAWER_HOME_SCREEN_ZONE_BUTTON_CLICK_EVENT(() => {
      this.setState({ ZoneModelOpen: true });
    });
    await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(() => {
      this.setState({ ZoneModelOpen: false });
    });

    await this.RenderMerchantAndSection();
    if (dto_Customer.CSID !== 0) {
      await this.IsForceToSignOut();
    }
    if (dto_Customer.CSID !== 0) {
      // if (CSP === "AV" && dto_Customer.CSID !== 0) {
      await this.IsPendingRatingAvailable();
      await this.IsPromoAvailable();
    }

    this.scroll();

    if (this.state.Promo !== 0) {
      document.body.classList.add("no-scroll");
    }

    if (CSP === "DT" || CSP === "MK") {
      setTimeout(async () => {
        await this.NotificationRedirect();
      }, 50);
    }

    if (CSP === "DT") {
      setTimeout(async () => {
        await this.DaitonnQrDivert();
      }, 50);
    }
  }

  async NotificationRedirect() {
    // let toNavigate = localStorage.getItem("toNavigate"); //Shud comment out this
    let toNavigate = await GET_PUSHNOTIFICATION_REDIRECT_URL();

    if (
      toNavigate &&
      (toNavigate.startsWith("/product-list") ||
        toNavigate.startsWith("/product"))
    ) {
      localStorage.setItem("TimeDifinvalid", true);

      // Extract and parse the MID
      const midMatch = toNavigate.match(/\/MID=(\d+)/);
      const MID = midMatch ? parseInt(midMatch[1]) : null;

      // Extract and parse MerchantZone
      const merchantZoneMatch = toNavigate.match(/\/MerchantZone=(\d+)/);
      const MerchantZone = merchantZoneMatch
        ? parseInt(merchantZoneMatch[1])
        : null;

      if (MerchantZone !== null && MerchantZone !== 0) {
        dto_common.ZoneId = MerchantZone;
        let ZoneDescription = null;

        switch (dto_common.ZoneId) {
          case 1490:
            ZoneDescription = "Male";
            break;
          case 3:
            ZoneDescription = "Hulhumale Phase2";
            break;
          case 15121:
            ZoneDescription = "Hulhumale";
            break;
        }

        dto_common.ZoneDescription = ZoneDescription;
        ENCRYPT_STORAGE.setItem(STORE_ZoneId, MerchantZone);
        ENCRYPT_STORAGE.setItem(STORE_ZoneDescription, ZoneDescription);
      }

      if (
        MID !== null &&
        (toNavigate.startsWith("/product-list") ||
          toNavigate.startsWith("/product"))
      ) {
        let data = await api_LoadMerchantForMID(dto_common.DineType, MID);
        let objData = JSON.parse(data);
        let MerchantInfo = JSON.parse(objData.MerchantInfo);
        let selectedMerchant = MerchantInfo[0];

        await set_dto_Merchant(selectedMerchant);
        // console.log("Selected Merchant:", selectedMerchant);
      }
      // localStorage.removeItem("toNavigate"); //Shud comment out this
      toNavigate = toNavigate.split("/MID")[0];
    }

    if (toNavigate) {
      this.props.navigate(toNavigate);
    }
  }

  async DaitonnQrDivert() {
    // GUIDE
    // url pattern: http://localhost:3000/{CSP}?{QR}?{secret_key}?{MID}
    // sample url : http://localhost:3000/DT?QR?abc1234?37
    let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (CSP !== "DT" || entryMode !== "QR") {
      return;
    }
    let mid = ENCRYPT_STORAGE.getItem(MID);
    let secretKey = ENCRYPT_STORAGE.getItem(SECRET_KEY);
    if (secretKey !== "abc1234" || mid === undefined) {
      ENCRYPT_STORAGE.removeItem(SECRET_KEY);
      ENCRYPT_STORAGE.removeItem(ENTRY_MODE);
      ENCRYPT_STORAGE.removeItem("FROM");
      ENCRYPT_STORAGE.removeItem(MID);
      ENCRYPT_STORAGE.removeItem(TABLE_NO);
      return;
    }
    dto_Merchant.MID = mid;

    try {
      const data = await api_LoadMerchantForMID(dto_common.DineType, mid);
      const objData = JSON.parse(data);
      const merchantInfo = JSON.parse(objData.MerchantInfo);
      if (Array.isArray(merchantInfo) && merchantInfo.length > 0) {
        await set_dto_Merchant(merchantInfo[0]);
      }
    } catch (error) {
      console.error("DaitonnQrDivert load merchant failed:", error);
    }
    this.props.navigate(`/product-list/none/MID=${mid}`);
  }

  async LoadMasterCategoryForMKB() {
    let merchant = ENCRYPT_STORAGE.getItem(STORE_MERCHANT);
    if (merchant.length === 1) {
      merchant[0].CATID = 0;
      await set_dto_Merchant(merchant[0]);
      if (CSP === "MK") {
        merchant[0].MT = "GR";
      }
    }
    let data = await api_CategoryPageLoadGroceryCategory();
    ENCRYPT_STORAGE.setItem("MasterCategory", {
      data: data,
      date: new Date(),
      MID: dto_selected_merchant_or_product.MID,
    });
    let objData = JSON.parse(data);
    this.setState({ MasterCategory: objData });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.Promo !== prevState.Promo) {
      if (this.state.Promo !== 0) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    }
  }

  scroll() {
    setTimeout(() => {
      let PID = ENCRYPT_STORAGE.getItem(STORE_MERCHANT_SCROLL);
      if (PID !== undefined) {
        let element = document.getElementById(PID);
        if (element) {
          let offsetTop = element.offsetTop;
          if (isMobile) {
            $("html,body").animate(
              {
                scrollTop: offsetTop - 140,
              },
              500,
            );
          } else {
            $(".WindowDevice").animate(
              {
                scrollTop: offsetTop - 140,
              },
              500,
            );
          }
        }
      }
    }, 100);
  }

  async IsPendingRatingAvailable() {
    let data = await ENCRYPT_STORAGE.getItem(STORE_RATING_POSID);
    if (data > 0) {
      this.setState({ POSID: data });
    }
  }

  async IsPromoAvailable() {
    let data = await ENCRYPT_STORAGE.getItem(STORE_PROMO_DATA);
    if (data && data.length > 0) {
      this.setState({ Promo: data });
    }
  }

  async IsForceToSignOut() {
    let data = await ENCRYPT_STORAGE.getItem(STORE_ISFORCE_TO_SIGN_OUT);
    if (data) {
      ALert.MessageBox({
        ConfirmButtonText: "Ok",
        ConfirmButtonFunction: async () => {
          this.setState({ isLoading: true });
          await ENCRYPT_STORAGE.removeMultipleItems([
            STORE_CSID,
            STORE_NIC,
            STORE_ZoneId,
            STORE_ZoneDescription,
            STORE_DeliveryZoneID,
            STORE_MTYPE,
            STORE_dtoMobileSettings,
            STORE_DineType,
            STORE_PhoneNo,
            STORE_SelectedMerchant,
            STORE_SelectedMerchantProduct,
            STORE_MobileAppCategory,
            STORE_CustomerName,
            STORE_dtoCustomerAddressList,
            STORE_CustomerDefaultAddress,
            TEMP_STORE_CSID,
            TEMP_STORE_PhoneNo,
            TEMP_STORE_CustomerName,
            TEMP_STORE_OTP,
            STORE_Cart,
            STORE_CartCheckoutData,
            STORE_Addons,
            STORE_FinaleSelelctCartMerchantNZone,
            STORE_PROMOTIONS,
            STORE_SHEDULEDateNTime,
            STORE_CustomerDefaultAddress,
          ]);

          let csp = ENCRYPT_STORAGE.getItem(STORE_CSP);
          let Version = ENCRYPT_STORAGE.getItem(STORE_HardReleaseVersion);
          if ((await VALIDATE_CSP(csp)) === true) {
            ENCRYPT_STORAGE.setItem(STORE_CSP, csp.toUpperCase());
            this.setState({ CSP: csp.toUpperCase() });
            await SET_STARTUP({ csp: csp, HardReleaseVersion: Version });
            SET_COLORS({ CSP: csp.toUpperCase() });
            SET_UPDATE_URL({ CSP: csp });
            let data = await api_checkAppStoreVersion();
            let objData = JSON.parse(data);

            if (objData === "UPDATE") {
              let device = window.navigator.appVersion;
              if (device !== undefined) {
                if (device.toUpperCase().includes("ANDROID")) {
                  window.location.href = Update.ANDROIDstoreURL;
                }
                if (device.toUpperCase().includes("IPHONE")) {
                  window.location.href = Update.IOSstoreURL;
                }
                if (device.toUpperCase().includes("IPAD")) {
                  window.location.href = Update.IOSstoreURL;
                }
              }
            } else {
              dto_common.MemmoryURl = JSON.parse(data);
              if (dto_common.MemmoryURl !== "") {
                let stup = await api_StartupPageLoad();
                await set_dto_StartupPageLoadInfo(JSON.parse(stup));
                this.setState({ isReady: true });
                await CHECK_NIC();

                setTimeout(() => {
                  this.setState({ isLoading: false });
                  SET_STORE_PAGE_URL(window.location.pathname);
                  this.props.navigate(PT_SIGNIN);
                }, 500);
              }
            }
          }
        },
        Tittle: "APOLOGIZE",
        Text: "Due to some system update please Re-Login",
      });
    }
  }

  async LoadFavouriteMerchantHere() {
    let Fav = await api_LoadCustomerWiseMerchantFavouriteListToMemory();
    let parseFav = JSON.parse(Fav);
    let parseFavObj = JSON.parse(parseFav);
    if (parseFav !== "[[]]") {
      let favouriteMerchant = parseFavObj[0];
      ENCRYPT_STORAGE.setItem(STORE_FAVOURITE_MERCHANT_LIST, favouriteMerchant);
      return favouriteMerchant;
    } else {
      return null;
    }
  }

  async LoadFavouriteMerchant(MerchantData) {
    try {
      let favouriteMerchant = await this.LoadFavouriteMerchantHere();

      if (favouriteMerchant) {
        // Sort favouriteMerchant by count in descending order
        favouriteMerchant.sort((a, b) => b.Count - a.Count);

        // Extracting the MID values from favouriteMerchant array
        let favouriteMIDs = favouriteMerchant.map((merchant) => merchant.MID);

        // Updating MerchantData with the IsFavourite attribute
        let UpdatedMerchantData = MerchantData.map((merchant) => ({
          ...merchant,
          IsFavourite: favouriteMIDs.includes(merchant.MID),
        }));

        // Filtering MerchantData to find merchants with matching MID values and MerchantData.IsOpen is true
        let favouriteMerchantsData = UpdatedMerchantData.filter((merchant) => {
          return favouriteMIDs.includes(merchant.MID) && merchant.IO;
        });

        // Sort favouriteMerchantsData based on the order of favouriteMerchant
        favouriteMerchantsData.sort((a, b) => {
          return favouriteMIDs.indexOf(a.MID) - favouriteMIDs.indexOf(b.MID);
        });

        this.setState(
          {
            FavouriteMerchant: favouriteMerchantsData,
            isDisplayFavourites: favouriteMerchantsData.length > 0,
            MerchantData2: UpdatedMerchantData,
          },
          () => {
            // console.log(this.state.MerchantData2[0]);
          },
        );

        ENCRYPT_STORAGE.setItem(STORE_MERCHANT, UpdatedMerchantData);
      } else {
        this.setState({
          isDisplayFavourites: false,
          MerchantData2: MerchantData,
        });

        ENCRYPT_STORAGE.setItem(STORE_MERCHANT, MerchantData);
      }
    } catch (error) {
      console.error("Error loading favourite merchants:", error);
    }
  }

  async RenderMerchantAndSection() {
    this.setState({ isLoading: true });
    let TimeDifinvalid = localStorage.getItem("TimeDifinvalid") || "false";

    let dataStorage = ENCRYPT_STORAGE.getItem("MerChantData");
    let results = "";
    let hasStoredData =
      dataStorage !== undefined &&
      dataStorage !== "" &&
      dataStorage.data &&
      Array.isArray(dataStorage.data) &&
      dataStorage.data.length === 2;

    let shouldReload = !hasStoredData;
    if (!shouldReload) {
      let StorageDateTime = dataStorage.date
        ? new Date(dataStorage.date)
        : null;
      let currentDateTime = new Date();

      let DifferenceMinute =
        TimeDifinvalid === "true" || !StorageDateTime
          ? Number.MAX_SAFE_INTEGER
          : DIFERENCE_MINUTES(currentDateTime, StorageDateTime);

      if (DifferenceMinute > 10) {
        shouldReload = true;
      }

      if (dataStorage.ZoneId !== dto_common.ZoneId) {
        shouldReload = true;
      }
    }

    localStorage.removeItem("TimeDifinvalid");

    if (shouldReload) {
      results = await Promise.all([this.LoadMerchant(), this.LoadSection()]);
      ENCRYPT_STORAGE.setItem("MerChantData", {
        data: results,
        date: new Date(),
        ZoneId: dto_common.ZoneId,
      });
    } else {
      results = dataStorage.data;
    }

    this.setState({
      NoOfMerchants: results[0].MerchantInfo.length,
      MerchantData: results[0].MerchantInfo,
      MobileAppCategoryDate: results[0].MobileAppCategory,
      NoOfMobileAppCategory: results[0].MobileAppCategory.length,
      NoOfSection: results[1].length,
      SectionsData: results[1],
      isLoading: false,
    });

    if (CSP === "AV") {
      if (dto_Customer.CSID > 0) {
        await this.LoadFavouriteMerchant(results[0].MerchantInfo);
      }
    }
  }

  async LoadMerchant() {
    try {
      ENCRYPT_STORAGE.removeItem("MerChantData");
      // Zeena20240202
      if (CSP !== "MK") {
        dto_common.DineType = 0;
      }

      let data = await api_LoadMerchant(dto_common.DineType);
      let objData = JSON.parse(data);
      let MobileAppCategory = objData.dtoMobileAppCategory;
      let MerchantInfo = JSON.parse(objData.MerchantInfo);

      ENCRYPT_STORAGE.setItem(STORE_MERCHANT, MerchantInfo);
      if (MerchantInfo.length === 1) {
        if (
          MerchantInfo[0].MT.toUpperCase() === "GR" ||
          MerchantInfo[0].MT.toUpperCase() === "AF"
        ) {
          MobileAppCategory = [];
        }
      }
      await api_DaitonnAnalytical();

      return {
        MerchantInfo: MerchantInfo,
        MobileAppCategory: MobileAppCategory,
      };
    } catch (error) {
      console.error("LoadMerchant : " + error);
    }
  }

  async LoadSection() {
    try {
      let data = await api_LoadPromotionCategorySection(false);
      let Sections = JSON.parse(data);
      return Sections;
    } catch (error) {
      console.error("LoadSection : " + error);
    }
  }

  handleCloseModal = async () => {
    this.setState({ POSID: 0 });
    ENCRYPT_STORAGE.setItem(STORE_RATING_POSID, 0);
  };

  handleClosePromoModal = async () => {
    this.setState({ Promo: 0 }, () => {
      document.body.classList.remove("no-scroll");
    });
    ENCRYPT_STORAGE.setItem(STORE_PROMO_DATA, 0);
  };

  renderPlaceholder() {
    switch (CSP) {
      case "AV":
        return <AVHomePlaceholder />;
      case "DT":
        return <DThomePlaceholder />;
      case "MK":
        return <MKhomePlaceholder />;
      default:
        return null;
    }
  }

  render() {
    const { POSID, Promo } = this.state;

    if (POSID > 0) {
      return (
        <Container
          style={{
            marginBottom: 60,
            marginTop: CSP !== "MK" ? 140 : 120,
            // marginTop: CSP !== "MK" ? 0 : 120,
          }}
        >
          <RateNow orderId={POSID} onCloseModal={this.handleCloseModal} />
        </Container>
      );
    }

    // Otherwise, render the default content
    return (
      <>
        <Container
          style={{
            marginBottom: 60,
            paddingTop: CSP !== "MK" ? 140 : 120,
          }}
        >
          <button
            style={{ display: "none" }}
            id="HomeScreenLoadEventCall"
            onClick={async () => {
              dto_common.SCHEDULEDDATE = "";
              dto_common.SCHEDULEDTIME = "";
              ENCRYPT_STORAGE.removeItem(STORE_SHEDULEDateNTime);
              await this.RenderMerchantAndSection();
            }}
          />

          {this.state.isLoading ? (
            this.renderPlaceholder()
          ) : (
            <>
              {/* buttons */}
              {/* <div
                onClick={() => {
                  localStorage.setItem("toNavigate", "/home");
                }}
              >
                set home nav
              </div>
              <div
                onClick={() => {
                  localStorage.setItem(
                    "toNavigate",
                    // "/product-list/none/MID=4/MerchantZone=0"
                    "/product-list/none/MID=389/MerchantZone=15121"
                  );
                }}
              >
                set product listnav
              </div>
              <div
                onClick={() => {
                  localStorage.setItem(
                    "toNavigate",
                    // "/product/home/product-list/picked%20for%20you/91018/1/1/0/MID=4/MerchantZone=0"
                    "/product/home/product-list/picked%20for%20you/105383/1/1/0/MID=80/MerchantZone=1490"
                  );
                }}
              >
                set product nav
              </div> */}
              {/* buttons */}

              {this.state.NoOfMerchants === 0 ? (
                <img
                  alt="Merchant"
                  src={require("./images/comingsoon.png")}
                  style={{ width: "100%" }}
                />
              ) : (
                <>
                  {this.state.NoOfMobileAppCategory > 0 && CSP === "AV" ? (
                    <ViewCategory
                      data={this.state.MobileAppCategoryDate}
                      navigate={this.props.navigate}
                    />
                  ) : null}

                  {this.state.MasterCategory.length > 0 && CSP === "MK" ? (
                    <ViewCategoryMK
                      Data={this.state.MasterCategory}
                      navigate={this.props.navigate}
                    />
                  ) : null}

                  {CSP === "MK" ? (
                    <SliderImage navigate={this.props.navigate} />
                  ) : (
                    ""
                  )}

                  {dto_Customer.CSID !== 0 &&
                  this.state.isDisplayFavourites === true ? (
                    <ViewSection
                      pmData={this.state.FavouriteMerchant}
                      Name={"MY FAVOURITES"}
                      navigate={this.props.navigate}
                      displayFav={true}
                      refreshHome={this.RenderMerchantAndSection}
                    />
                  ) : (
                    ""
                  )}

                  <Sections
                    data={this.state.SectionsData}
                    navigate={this.props.navigate}
                    displayFav={false}
                    refreshHome={null}
                  />

                  {dto_Customer.CSID !== 0 && CSP !== "DT"
                    ? this.state.MerchantData2.map &&
                      this.state.MerchantData2.map((rs, i) => {
                        return (
                          <MerchantCard
                            key={rs.MID + "MerchantCard" + i}
                            data={rs}
                            navigate={this.props.navigate}
                            refreshHome={this.RenderMerchantAndSection}
                            onScroll={() => {
                              const scrollIndex = rs.MID + "MerchantCard";
                              ENCRYPT_STORAGE.setItem(
                                STORE_MERCHANT_SCROLL,
                                scrollIndex,
                              );
                            }}
                          />
                        );
                      })
                    : CSP !== "MK" &&
                      this.state.MerchantData.map &&
                      this.state.MerchantData.map((rs, i) => {
                        return (
                          <MerchantCard
                            key={rs.MID + "MerchantCard" + i}
                            id={rs.MID + "MerchantCard" + i}
                            data={rs}
                            navigate={this.props.navigate}
                            refreshHome={this.RenderMerchantAndSection}
                            onScroll={() => {
                              const scrollIndex = rs.MID + "MerchantCard";
                              ENCRYPT_STORAGE.setItem(
                                STORE_MERCHANT_SCROLL,
                                scrollIndex,
                              );
                            }}
                          />
                        );
                      })}
                </>
              )}
            </>
          )}

          <DrawerSheetBottom
            open={this.state.ZoneModelOpen}
            displayCloseIcon="block"
            Heading="SELECT ZONE"
            size={isMobile ? "85%" : 280}
            element={
              <RENDER_DRAWER_ZONE
                SelectZone={async (rs) => {
                  ENCRYPT_STORAGE.removeItem("MerChantData");
                  dto_common.ZoneId = rs.PID;
                  dto_common.ZoneDescription = rs.Description;
                  ENCRYPT_STORAGE.setItem(STORE_ZoneId, rs.PID);
                  ENCRYPT_STORAGE.setItem(
                    STORE_ZoneDescription,
                    rs.Description,
                  );
                  SET_ZONE_DESCRIPTION_HOME_SCREEN(
                    rs.Description.toUpperCase(),
                  );
                  this.setState({ ZoneModelOpen: false });
                  await this.RenderMerchantAndSection();
                }}
              />
            }
          />
        </Container>

        {/* Promo Section */}
        {Promo !== 0 && (
          <Container
            fluid="sm"
            style={{
              marginBottom: 60,
              marginTop: CSP !== "MK" ? 140 : 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "absolute",
                backgroundColor: "rgba(0, 0, 0,0.7)",
                top: 0,
                right: 0,
                width: "100%",
                height: "100%",
                paddingTop: "70%",
                padding: "5%",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 50000,
                overflow: "auto",
              }}
            >
              <PromoCard
                PromoCode={Promo[0][0].PromoCode}
                PromoHeading={Promo[0][0].PromoHeading}
                Description={Promo[0][0].Description}
                DiscAmount={Promo[0][0].DiscAmount}
                DiscPercentage={Promo[0][0].DiscPercentage}
                onCloseModal={this.handleClosePromoModal}
              />
            </div>
          </Container>
        )}
      </>
    );
  }
}
